// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"315":"463a4e160041f238","528":"f5c155b07db570be","888":"1bcbeaf13c77697a","988":"8513b4e047f81d21"}[chunkId] + ".css";
};